<template>
  <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showHeader="true" :showFooter="true" @modalClosed="modalClosed" :bodyStyle="'padding: 0px !important;'">
    <template #header>
      <button type="button" id="close-modal-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
    </template>
    <template #body>
      <div class="row h-100 m-0">
        <div :class="showSendForm ? 'col-md-8' : 'col-12'" class="p-0 position-relative">
          <div v-if="loading" style="z-index:9999;position: absolute;background: white;left: 0;right: 0;height: 0;bottom: 0;width: 100%;height: 100%;text-align: center;padding-top: 2rem;">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Generating document...</p>
          </div>
          
          <!-- Hidden container for html2pdf rendering -->
          <div id="contract-preview-container" v-show="!pdfUrl">
            <div id="contract-container">
              <div id="layout-contract"></div>
            </div>
          </div>

          <!-- PDF Preview Iframe -->
          <iframe v-if="pdfUrl && !isMobile" :src="pdfUrl" type="application/pdf" width="100%" height="800px" style="border: none;">
            <p>Sorry, your browser doesn't support embedded PDFs. <a :href="pdfUrl" download>Download</a></p>
          </iframe>

          <!-- Mobile view -->
          <div v-if="pdfUrl && isMobile" class="text-center py-5">
            <AppIcon name="bi-file-earmark-pdf" class="bi bi-file-earmark-pdf" style="font-size: 64px; color: #dc3545;" />
            <h5 class="mt-3 mb-4">{{$t('document_ready')}}</h5>
            <button type="button" class="btn btn-success btn-lg" @click="downloadPdf">
              <AppIcon name="bi-download" class="bi bi-download me-2" />{{$t('download_pdf')}}
            </button>
          </div>

        </div>
        <div v-if="showSendForm" class="col-md-4 border-start p-3 bg-light">
            <div v-if="!emailSent">
                <h5 class="mb-3">{{$t('send_email')}}</h5>
                <div class="mb-3">
                    <label class="form-label">{{$t('email')}} <span class="text-danger">*</span></label>
                    <input type="email" class="form-control" v-model="emailForm.email" :placeholder="$t('enter_email_address')" style="background-color: white !important; border: 1px solid #ced4da !important;">
                </div>
                <div class="mb-3">
                    <label class="form-label">{{$t('subject')}}</label>
                    <input type="text" class="form-control" v-model="emailForm.subject" :placeholder="$t('enter_subject')" style="background-color: white !important; border: 1px solid #ced4da !important;">
                </div>
                <div class="mb-3">
                    <label class="form-label">{{$t('message')}}</label>
                    <textarea class="form-control" v-model="emailForm.message" rows="6" :placeholder="$t('enter_message')" style="background-color: white !important; border: 1px solid #ced4da !important;"></textarea>
                </div>
            </div>
            <div v-else class="h-100 d-flex flex-column justify-content-center align-items-center text-center">
                <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill text-success" style="font-size: 4rem;" />
                <h5 class="mt-3">{{$t('email_sent_successfully')}}</h5>
            </div>
        </div>
      </div>
    </template>
    <template #footer>
      <button v-if="showSendForm && !emailSent" type="button" class="btn btn-success" @click="sendEmail" :disabled="!emailForm.email">
        <AppIcon name="bi-send" class="bi bi-send me-1" /> {{$t('send')}}
      </button>
      <button v-if="showSaveButton && !showSendForm" type="button" class="btn btn-primary" @click="saveDocument">
        <AppIcon name="bi-check-circle" class="bi bi-check-circle me-1" /> {{$t('save_document')}}
      </button>
      <button v-if="!showSendForm && !showSaveButton && pdfUrl" type="button" class="btn btn-success" @click="downloadPdf">
        <AppIcon name="bi-download" class="bi bi-download me-1" />
        {{$t('download_pdf')}}</button>
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="modalClosed"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from "../../helper";
import html2pdf from 'html2pdf.js'

export default {
  name: "ContractTemplateModal",
  components: {
    CustomModal
  },
  props: {
    data: {
      type: Object,
    },
    employee: {
      type: Object,
      default: () => ({})
    },
    isModalOpen: {
      type: Boolean,
      default: false
    },
    modalId: {
      type: String,
      default: 'contractModal'
    },
    showSendForm: {
      type: Boolean,
      default: false
    },
    showSaveButton: {
      type: Boolean,
      default: false
    },
    defaultEmail: {
      type: String,
      default: ''
    },
    emailSent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      item: {},
      logoBase64: null,
      pdfUrl: null,
      loading: true,
      fileName: 'contract.pdf',
      isMobile: false,
      emailForm: {
        email: '',
        subject: '',
        message: ''
      }
    };
  },
  methods: {
    formatDate(date) {
      return helper.formatDate(date, false, 'DD/MM/YYYY');
    },
    async generatePDFPreview() {
      this.loading = true;
      const element = document.getElementById('contract-container');
      
      const opt = {
        // Page spacing is already carried by .contract-page-wrapper. Adding a
        // second PDF margin here made a saved 0px margin/padding render with a
        // visible border around every contract.
        margin: 0,
        filename: this.generateFileName(),
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff',
          letterRendering: true
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
        pagebreak: {
          mode: ['css', 'legacy'],
          avoid: [
            '.contract-section-header',
            '.contract-section-footer',
            'h1',
            'h2',
            'h3',
            'blockquote',
            'table',
            'tr',
            'img'
          ]
        },
        enableLinks: true
      };

      try {
        await this.waitForImages(element);
        const worker = html2pdf().from(element).set(opt).toPdf();
        const pdf = await worker.get('pdf');
        this.finishPdf(pdf);
        const pdfBlob = pdf.output('blob');
        if (this.pdfUrl) {
          URL.revokeObjectURL(this.pdfUrl);
        }
        this.pdfUrl = URL.createObjectURL(pdfBlob);
      } catch (error) {
        this.$toast.open({ 
          message: this.$t('error_generating_pdf'), 
          type: 'error' 
        });
      } finally {
        this.loading = false;
      }
    },
    generateFileName() {
      const ref = this.item.reference || this.item.contract_number ? (this.item.reference || this.item.contract_number).replace(/\//g, '-') : 'document';
      const timestamp = new Date().getTime();
      this.fileName = `document-${ref}-${timestamp}.pdf`;
      return this.fileName;
    },
    downloadPdf() {
      if (this.pdfUrl) {
        const link = document.createElement('a');
        link.href = this.pdfUrl;
        link.download = this.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    async getBase64Image(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();
        await new Promise((resolve, reject) => {
          reader.onload = resolve;
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
        return reader.result;
      } catch (error) {
        this.$toast.open({ 
          message: this.$t('error_loading_image'), 
          type: 'error' 
        });
        return null;
      }
    },
    replaceVariables(content) {
      if (!content) return '';

      const business = this.business || {};
      const employee = this.employee && Object.keys(this.employee).length
        ? this.employee
        : (this.item.employee || {});
      const entity = employee.name
        ? employee
        : (this.item.client || this.item.supplier || this.item.employee || {});
      const contractNumber = this.item.contract_number || this.item.reference || '';
      const values = {
        'business.name': business.name,
        'business.email': business.email,
        'business.address': business.address,
        'business.phone': business.phone,
        'business.website': business.website,
        'company.name': business.name,
        'company.email': business.email,
        'company.address': business.address,
        'company.phone': business.phone,
        'contract.title': this.item.title || 'Contract',
        'contract.number': contractNumber,
        'contract.contract_number': contractNumber,
        'contract.amount': this.item.amount,
        'contract.start_date': this.item.start_date ? this.formatDate(this.item.start_date) : '',
        'contract.end_date': this.item.end_date ? this.formatDate(this.item.end_date) : '',
        'entity.name': entity.name,
        'entity.email': entity.email,
        'entity.phone': entity.phone,
        'entity.address': entity.address,
        'employee.name': employee.name,
        'employee.position': employee.position,
        'employee.department': employee.department,
        'employee.address': employee.address,
        'employee.email': employee.email,
        'employee.phone': employee.phone,
        'employee.salary': employee.salary,
        'employee.hire_date': employee.hire_date ? this.formatDate(employee.hire_date) : '',
        'employee.national_id': employee.national_id,
        'current_date': this.formatDate(new Date()),
        'date': this.formatDate(new Date())
      };

      return content.replace(/\{\{?([a-zA-Z0-9_.]+)\}?\}/g, (match, key) => {
        if (!Object.prototype.hasOwnProperty.call(values, key)) return match;
        return this.escapeHtml(values[key] == null ? '' : values[key]);
      });
    },
    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },
    prepareContractMarkup(content) {
      const container = document.createElement('div');
      container.innerHTML = this.replaceVariables(content || '');

      let wrapper = container.querySelector('.contract-page-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'contract-page-wrapper';
        while (container.firstChild) {
          wrapper.appendChild(container.firstChild);
        }
        container.appendChild(wrapper);
      }

      const pagePadding = this.readSpacing(wrapper.style.padding, 20, 64);
      const pageMargin = this.readSpacing(wrapper.style.margin, 0, 48);
      wrapper.style.removeProperty('padding');
      wrapper.style.removeProperty('margin');

      let sectionRoot = wrapper.querySelector('.contract-document-sections');
      if (!sectionRoot) {
        sectionRoot = document.createElement('div');
        sectionRoot.className = 'contract-document-sections';

        const header = document.createElement('header');
        header.className = 'contract-section contract-section-header contract-section-empty';
        header.setAttribute('data-contract-section', 'header');

        const body = document.createElement('main');
        body.className = 'contract-section contract-section-body';
        body.setAttribute('data-contract-section', 'body');
        while (wrapper.firstChild) {
          body.appendChild(wrapper.firstChild);
        }

        const footer = document.createElement('footer');
        footer.className = 'contract-section contract-section-footer contract-section-empty';
        footer.setAttribute('data-contract-section', 'footer');

        sectionRoot.appendChild(header);
        sectionRoot.appendChild(body);
        sectionRoot.appendChild(footer);
        wrapper.appendChild(sectionRoot);
      }

      ['header', 'body', 'footer'].forEach(sectionName => {
        const section = sectionRoot.querySelector(`[data-contract-section="${sectionName}"]`)
          || sectionRoot.querySelector(`.contract-section-${sectionName}`);
        if (!section) return;
        section.classList.add('contract-section', `contract-section-${sectionName}`);
        section.classList.toggle('contract-section-empty', !this.hasPrintableContent(section));
      });

      return {
        html: container.innerHTML,
        pagePadding,
        pageMargin
      };
    },
    readSpacing(value, fallback, maximum) {
      const match = String(value || '').match(/-?\d+(\.\d+)?/);
      const number = match ? Number(match[0]) : fallback;
      return Math.min(Math.max(number, 0), maximum);
    },
    hasPrintableContent(element) {
      const text = (element.textContent || '').replace(/\u00a0/g, ' ').trim();
      return Boolean(text || element.querySelector('img, table, video, iframe, hr'));
    },
    async waitForImages(element) {
      const images = Array.from(element.querySelectorAll('img'));
      await Promise.all(images.map(image => {
        if (image.complete) return Promise.resolve();
        return new Promise(resolve => {
          const finish = () => resolve();
          image.addEventListener('load', finish, { once: true });
          image.addEventListener('error', finish, { once: true });
          setTimeout(finish, 3000);
        });
      }));
    },
    finishPdf(pdf) {
      const pageCount = pdf.internal.getNumberOfPages();
      pdf.setProperties({
        title: this.item.title || this.fileName,
        subject: this.item.contract_number || this.item.reference || '',
        creator: (this.business && this.business.name) || 'GStocky'
      });
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(112, 118, 128);

      for (let page = 1; page <= pageCount; page += 1) {
        pdf.setPage(page);
        pdf.text(`${page} / ${pageCount}`, 194, 290, { align: 'right' });
      }
    },
    modalClosed() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
        this.pdfUrl = null;
      }
      this.isModalOpen = false;
      this.$emit('modalClosed', true);
    },
    async sendEmail() {
        if (!this.pdfUrl) return;
        
        try {
            this.loading = true;
            const response = await fetch(this.pdfUrl);
            const blob = await response.blob();
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                this.$emit('sendEmail', {
                    ...this.emailForm,
                    pdf_base64: base64data,
                    filename: this.fileName
                });
                this.loading = false;
            }
        } catch (error) {
            this.loading = false;
            alert('Error generating PDF for email');
        }
    },
    async saveDocument() {
        if (!this.pdfUrl) return;
        try {
            this.loading = true;
            const response = await fetch(this.pdfUrl);
            const blob = await response.blob();
            this.$emit('save', blob);
            this.loading = false;
        } catch (error) {
            this.loading = false;
            alert('Error saving document');
        }
    }
  },
  computed: {
    business() { return this.$store.getters.BUSINESS; },
    user() { return this.$store.getters.USER; },
  },
  async mounted() {
    this.loading = true;
    this.isMobile = window.innerWidth < 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.item = this.data || {};
    
    if(this.defaultEmail){
        this.emailForm.email = this.defaultEmail
    }

    if (this.item.reference || this.item.contract_number) {
        this.emailForm.subject = this.item.reference || this.item.contract_number;
    }
    
    this.logoBase64 = this.business?.logo ? await this.getBase64Image(this.business.logo) : null;

    const preparedContract = this.prepareContractMarkup(this.item.content || '');
    const contractContainer = document.getElementById('contract-container');
    contractContainer.style.setProperty('--contract-page-padding', `${preparedContract.pagePadding}px`);
    contractContainer.style.setProperty('--contract-page-margin', `${preparedContract.pageMargin}px`);
    document.getElementById("layout-contract").innerHTML = preparedContract.html;
      
    // Inject logo if found in template
    if(this.logoBase64) {
        const imgs = document.getElementById("layout-contract").getElementsByTagName('img');
        for(let img of imgs) {
            const source = img.getAttribute('src') || '';
            if (source.includes('business.logo') || img.id === 'uploadedLogo') {
                img.src = this.logoBase64;
            }
        }
    }
    
    // Generate PDF preview after content is rendered
    this.$nextTick(() => {
      setTimeout(() => {
        this.generatePDFPreview();
      }, 500);
    });
  }
};
</script>
<style>
#contract-preview-container {
  position: absolute;
  top: 0;
  left: -9999px;
  width: 210mm;
  background: #f8f9fa;
}

#contract-container {
  width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  color: #20242c;
  font-family: "Times New Roman", Times, serif;
  font-size: 11pt;
  line-height: 1.58;
  background: #fff;
  box-sizing: border-box;
}

#layout-contract {
  display: flex;
  min-height: 297mm;
}

#contract-container .contract-page-wrapper {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  padding: var(--contract-page-padding, 20px) !important;
  margin: var(--contract-page-margin, 0) !important;
  box-sizing: border-box;
}

#contract-container .contract-document-sections {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

#contract-container .contract-builder-v2 {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  background: transparent !important;
}

#contract-container .contract-block {
  max-width: 100%;
  box-sizing: border-box;
  page-break-inside: avoid;
  break-inside: avoid;
}

#contract-container .contract-block-text,
#contract-container .contract-block-clause {
  page-break-inside: auto;
  break-inside: auto;
}

#contract-container .contract-block > :first-child {
  margin-top: 0;
}

#contract-container .contract-block > :last-child {
  margin-bottom: 0;
}

#contract-container .contract-block img {
  max-width: 100%;
  height: auto;
}

#contract-container .contract-section-header {
  flex: 0 0 auto;
  padding-bottom: 7mm;
  border-bottom: 1px solid #cfd4dc;
  page-break-inside: avoid;
  break-inside: avoid;
}

#contract-container .contract-section-body {
  flex: 1 1 auto;
  padding: 9mm 0 10mm;
}

#contract-container .contract-section-footer {
  flex: 0 0 auto;
  padding-top: 7mm;
  margin-top: auto;
  border-top: 1px solid #cfd4dc;
  page-break-inside: avoid;
  break-inside: avoid;
}

#contract-container .contract-section-empty {
  display: none;
}

#contract-container h1,
#contract-container h2,
#contract-container h3 {
  color: #151922;
  font-family: "Times New Roman", Times, serif;
  line-height: 1.25;
  page-break-after: avoid;
  break-after: avoid;
}

#contract-container h1 {
  margin: 0 0 8mm;
  font-size: 22pt;
}

#contract-container h2 {
  margin: 8mm 0 4mm;
  font-size: 15pt;
}

#contract-container h3 {
  margin: 6mm 0 3mm;
  font-size: 12pt;
}

#contract-container p,
#contract-container li {
  margin: 0 0 4mm;
  orphans: 3;
  widows: 3;
  page-break-inside: avoid;
  break-inside: avoid;
}

#contract-container ul,
#contract-container ol {
  margin: 0 0 5mm;
  padding-left: 7mm;
}

#contract-container li {
  margin-bottom: 2mm;
}

#contract-container blockquote {
  padding: 3mm 5mm;
  margin: 5mm 0;
  color: #424957;
  background: #f6f7f9;
  border-left: 3px solid #697386;
  page-break-inside: avoid;
  break-inside: avoid;
}

#contract-container table {
  width: 100%;
  margin: 5mm 0;
  border-collapse: collapse;
  page-break-inside: avoid;
  break-inside: avoid;
}

#contract-container th,
#contract-container td {
  padding: 2.5mm 3mm;
  vertical-align: top;
  border: 1px solid #d8dce3;
}

#contract-container th {
  font-weight: 700;
  background: #f3f4f6;
}

#contract-container img {
  max-width: 100%;
  height: auto;
  page-break-inside: avoid;
  break-inside: avoid;
}

#contract-container .contract-section > :first-child {
  margin-top: 0;
}

#contract-container .contract-section > :last-child {
  margin-bottom: 0;
}

.ql-align-center {
  text-align: center;
}
.ql-align-right {
  text-align: right;
}
.ql-align-justify {
  text-align: justify;
}

/* Quill Indentation */
.ql-indent-1 { padding-left: 3em; }
.ql-indent-2 { padding-left: 6em; }
.ql-indent-3 { padding-left: 9em; }
.ql-indent-4 { padding-left: 12em; }
.ql-indent-5 { padding-left: 15em; }
.ql-indent-6 { padding-left: 18em; }
.ql-indent-7 { padding-left: 21em; }
.ql-indent-8 { padding-left: 24em; }

.ql-font-arial { font-family: Arial, Helvetica, sans-serif; }
.ql-font-times-new-roman { font-family: "Times New Roman", Times, serif; }
.ql-font-courier-new { font-family: "Courier New", Courier, monospace; }
.ql-font-georgia { font-family: Georgia, serif; }
.ql-font-verdana { font-family: Verdana, Geneva, sans-serif; }
.ql-font-tahoma { font-family: Tahoma, Geneva, sans-serif; }
.ql-font-trebuchet-ms { font-family: "Trebuchet MS", Helvetica, sans-serif; }
</style>
